import React from 'react';
import _ from 'lodash';
import FeedContainerSmall from './FeedContainerSmall.jsx';

const RowWithTwo = ({articles, className}) => {
  const filtered = _.filter(articles, Boolean);
  return filtered.length ? (<div className="row">
     {
         _.map(filtered, article =>
             <div key={article.id} className={`template-item col-xs-6 ${className}`}>
                 <FeedContainerSmall contentContainer={article} />
             </div>
         )
     }
   </div>) : null;
};

export default RowWithTwo;



// WEBPACK FOOTER //
// ./src/component/NewsFeed/RowWithTwo.jsx